import React, { useEffect, useState } from 'react';
import { Grid, Header, Label, Menu, Placeholder } from 'semantic-ui-react';
import NotificationCard from './NotificationCard';
import { useDispatch } from 'react-redux';
import { getUserNotifications } from '../../actions/users';
import { reduceNotificationCount } from '../../actions/notifications';

const MENU = {
    NOTIFICATIONS: 'NOTIFICATIONS',
    FUTURE_NOTIFICATIONS: 'FUTURE_NOTIFICATIONS'
};

const NotificationComponent = (props) => {
    const dispatcher = useDispatch();
    const [loading, setLoading] = useState(true);
    const [notifications, setNotifications] = useState([]);
    const [futureNotifications, setFutureNotifications] = useState([]);

    useEffect(() => {
        fetchInit();
    }, []);

    const fetchInit = async () => {
        setLoading(true);
        try {
            const response = await dispatcher(getUserNotifications());
            setNotifications(response?.data?.notifications);
            setFutureNotifications(response?.data?.futureNotifications);
            setLoading(false);
        } catch ({ message }) {
            setLoading(false);
        }
    };

    const onRemoveNotification = async (id) => {
        setNotifications(notifications.filter((el) => el.id !== id));
        setFutureNotifications(futureNotifications.filter((el) => el.id !== id));
        reduceNotificationCount(dispatcher);
    };

    return (
        <div className="notifications">
            <div className="header-row">
                <Header as="h5">Notifications</Header>
            </div>
            <div className="notification-card-container">
                {loading ? (
                    <Placeholder>
                        <Placeholder.Paragraph className="card-container-placeholder">
                            <Placeholder.Line length="full" className="card" />
                            <Placeholder.Line length="full" />
                            <Placeholder.Line length="full" />
                        </Placeholder.Paragraph>
                    </Placeholder>
                ) : (
                    <>
                        {notifications?.length > 0 ? (
                            notifications.map((el) => <NotificationCard data={el} onRemoveNotification={onRemoveNotification} />)
                        ) : (
                            <div className="card-container-placeholder">
                                <div className="card">
                                    <div className="center padding-one-em">There are no new notification (s)</div>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default NotificationComponent;
